<template>
    <span class="estrellas" :title="valor === null || valor === undefined ? 'Sin calificar' : `${valor} de 5`">
        <i v-for="(tipo, i) in iconos" :key="i" :class="tipo"></i>
    </span>
</template>

<script>
import { computed } from "vue";

// Muestra un promedio de 1 a 5 como estrellas (llena / media / vacía)
export default {
    name: "Estrellas",
    props: {
        valor: { type: Number, default: null },
    },
    setup(props) {
        const iconos = computed(() => {
            const v = Number(props.valor || 0);
            return [1, 2, 3, 4, 5].map((n) => {
                if (v >= n - 0.25) return "fas fa-star llena";
                if (v >= n - 0.75) return "fas fa-star-half-alt llena";
                return "far fa-star vacia";
            });
        });
        return { iconos };
    },
};
</script>

<style scoped>
.estrellas {
    display: inline-flex;
    gap: 1px;
    font-size: 0.72rem;
    white-space: nowrap;
}

.llena {
    color: #F59E0B;
}

.vacia {
    color: #CBD5E1;
}
</style>
